import { useMemo } from 'react';
import { Application } from '../../types/Application';
import { useGet } from '../../../../api';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';

export type ApplicationByIdDto = { data?: Application };

export const useGetApplicationById = (id?: string) => {
    const { data, loading } = useGet<ApplicationByIdDto>({
        url: `${ACCESS_ANALYSIS_BASE_URL}/applications/${id}`
    });

    const application = useMemo(() => {
        if (!data?.data) return undefined;

        return data.data;
    }, [data]);

    return { application, loading };
};
